import { Outlet } from "react-router-dom";

// AdminLayout used to render its own tab strip but those tabs now live in the
// outer Layout's top nav (admins-only). Keeping AdminLayout as a thin Outlet
// wrapper preserves the route shape without duplicating navigation.
export function AdminLayout() {
  return <Outlet />;
}
